import axios from 'axios';

import { calculateBreakeven } from "@/api/utils";

export default {
  async list() {
    const { data } = await axios.get('https://8xiscecoe2.execute-api.ap-northeast-1.amazonaws.com/production/hashpower/lifetime/list');
    return data;
  },
  getFullData(item, coin, blockchainInfo) {
    const blockchain = blockchainInfo[coin];

    let priceUsd, priceBtc, priceCoin;
    if (item.price) {
      priceUsd = item.price;
      priceBtc = priceUsd / blockchainInfo.BTC.price;
      priceCoin = priceUsd / blockchain.price;
    } else if (item.priceUsd) {
      priceUsd = item.priceUsd;
      priceBtc = priceUsd / blockchainInfo.BTC.price;
      priceCoin = priceUsd / blockchain.price;
    } else if (item.priceCoin) {
      priceUsd = item.priceCoin * blockchainInfo[coin].price;
      priceBtc = priceUsd / blockchainInfo.BTC.price;
      priceCoin = item.priceCoin;
    }

    const payoff = blockchain.miningEarning * blockchain.price;
    const breakevenDays = calculateBreakeven(priceUsd, payoff, item.elecFeeUnit, blockchain.halvingTs, 365 * 20);

    return {
      dealWithHalving: true,
      ...item,
      coin, priceUsd, priceBtc, priceCoin,
      url: 'https://veryhash.com/trading?t=top',
      payoff,
      payoffCoin: blockchain.miningEarning,
      breakevenDays: breakevenDays
    };
  }
}